import { render, staticRenderFns } from "./NewDownload.vue?vue&type=template&id=436122cd&scoped=true&"
import script from "./NewDownload.vue?vue&type=script&lang=js&"
export * from "./NewDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436122cd",
  null
  
)

export default component.exports